import React, { useState } from "react";
import { useAuth, obtenerAutorizacion } from "../contexts/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const { login, loginWithGoogle } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError("Correo o contraseña incorrectos");
      setLoading(false);
    }
  }

  async function handleGoogle() {
    setError("");
    setLoadingGoogle(true);
    try {
      const result = await loginWithGoogle();
      const autorizacion = await obtenerAutorizacion(result?.user?.email || "");
      if (!autorizacion) {
        await result.user.delete().catch(() => {});
        throw new Error("no_permitido");
      }
    } catch (err) {
      if (err.message === "no_permitido") {
        setError("Este correo no tiene acceso al sistema.");
      } else if (err.code !== "auth/popup-closed-by-user") {
        setError("Error al iniciar con Google. Intenta de nuevo.");
      }
      setLoadingGoogle(false);
    }
  }

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.logoArea}>
          <div style={styles.logoCircle}>🍣</div>
          <h1 style={styles.brand}>Grupo Operador de<br />Alimentos y Marcas</h1>
          <p style={styles.sub}>Sistema de Administración</p>
        </div>

        {/* Google Sign-In */}
        <button
          onClick={handleGoogle}
          disabled={loadingGoogle || loading}
          style={styles.googleBtn}
          onMouseEnter={e => e.currentTarget.style.background = "#f5f5f5"}
          onMouseLeave={e => e.currentTarget.style.background = "#fff"}
        >
          {loadingGoogle ? (
            <span>Conectando...</span>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 48 48" style={{ marginRight: "10px", flexShrink: 0 }}>
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Continuar con Google
            </>
          )}
        </button>

        <div style={styles.divider}>
          <span style={styles.dividerLine} />
          <span style={styles.dividerText}>o con correo</span>
          <span style={styles.dividerLine} />
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <div style={styles.field}>
            <label style={styles.label}>Correo electrónico</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com"
              required
              onFocus={e => e.target.style.borderColor = "#C8A96E"}
              onBlur={e => e.target.style.borderColor = "#2a2a2a"}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Contraseña</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              onFocus={e => e.target.style.borderColor = "#C8A96E"}
              onBlur={e => e.target.style.borderColor = "#2a2a2a"}
            />
          </div>

          <button
            type="submit"
            disabled={loading || loadingGoogle}
            style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
            onMouseEnter={e => !(loading || loadingGoogle) && (e.target.style.background = "#b8964f")}
            onMouseLeave={e => e.target.style.background = "#C8A96E"}
          >
            {loading ? "Entrando..." : "Iniciar sesión"}
          </button>
        </form>

        <p style={styles.footer}>GOAM Admin · {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight: "100vh", background: "linear-gradient(135deg, #0a0a0a 0%, #1a1410 50%, #0a0a0a 100%)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', padding: "20px" },
  card: { background: "#111", border: "1px solid #2a2a2a", borderRadius: "16px", padding: "48px 40px", width: "100%", maxWidth: "400px", boxShadow: "0 40px 80px rgba(0,0,0,0.8)" },
  logoArea: { textAlign: "center", marginBottom: "32px" },
  logoCircle: { fontSize: "48px", marginBottom: "12px", display: "block" },
  brand: { color: "#C8A96E", fontSize: "19px", fontWeight: "600", letterSpacing: "1px", lineHeight: "1.35", margin: "0 0 6px", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
  sub: { color: "#666", fontSize: "13px", margin: 0, letterSpacing: "2px", fontFamily: "sans-serif" },
  googleBtn: { width: "100%", background: "#fff", border: "1px solid #ddd", borderRadius: "8px", padding: "13px 16px", fontSize: "14px", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif", transition: "background 0.2s", color: "#333" },
  divider: { display: "flex", alignItems: "center", gap: "12px", margin: "20px 0" },
  dividerLine: { flex: 1, height: "1px", background: "#2a2a2a" },
  dividerText: { color: "#444", fontSize: "12px", fontFamily: "sans-serif", whiteSpace: "nowrap" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  field: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { color: "#888", fontSize: "12px", letterSpacing: "1px", fontFamily: "sans-serif", textTransform: "uppercase" },
  input: { background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "8px", padding: "14px 16px", color: "#fff", fontSize: "15px", outline: "none", transition: "border-color 0.2s", fontFamily: "sans-serif" },
  btn: { background: "#C8A96E", color: "#000", border: "none", borderRadius: "8px", padding: "16px", fontSize: "14px", letterSpacing: "2px", fontWeight: "bold", cursor: "pointer", transition: "background 0.2s", fontFamily: "sans-serif", marginTop: "4px" },
  error: { background: "#2d1a1a", border: "1px solid #5a2020", color: "#ff6b6b", padding: "12px 16px", borderRadius: "8px", fontSize: "14px", fontFamily: "sans-serif" },
  footer: { textAlign: "center", color: "#333", fontSize: "12px", marginTop: "32px", marginBottom: 0, fontFamily: "sans-serif" }
};
